import axios, { AxiosInstance } from "axios";
import { b64_to_utf8, utf8_to_b64 } from "utils/functions";

let api: AxiosInstance;

const defaultBaseURL = "https://api.locoptics.ly/api";

export function createApi(): AxiosInstance {
  const baseURL =
    (import.meta.env.VITE_API_URL as string | undefined)?.trim() || defaultBaseURL;
  api = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  const token = localStorage.getItem("token");
  if (token) setToken(token);

  return api;
}

export function setToken(token: string): void {
  localStorage.setItem("token", token);
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export function deleteToken(): void {
  localStorage.removeItem("token");
  if (api?.defaults?.headers?.common) {
    delete api.defaults.headers.common.Authorization;
  }
}

export function useApi(): AxiosInstance {
  if (!api) {
    createApi();
  }

  return api;
}
